import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failurelistCountryList,
  successlistCountryList,
} from "./ListCountryListSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { IState } from "../../../Pages/Yearlevel_map/IYearlevel_map";
import { failurelistState, successlistState } from "./ListStateSlice";

// list
const ListCountryListApi = () => {
  return api.get("/api/category/country");
};

export function* ListCountryListCall() {
  try {
    const response: AxiosResponse = yield call(ListCountryListApi);
    yield put(successlistCountryList(response.data));
  } catch (error) {
    yield put(failurelistCountryList(error));
  }
}

const ListStateApi = (action: PayloadAction<IState>) => {
  return api.get("/api/category/state", {
    params: action.payload,
  });
};

export function* ListStateCall(action: PayloadAction<IState>) {
  try {
    const response: AxiosResponse = yield call(ListStateApi, action);
    yield put(successlistState(response.data));
  } catch (error) {
    yield put(failurelistState(error));
  }
}
